import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      links={[
        {
          key: 'BW Shutters & Blinds Pty Ltd',
          title: 'BW Shutters & Blinds Pty Ltd',
          href: 'https://www.luxsol.com.au/',
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
